<template>
  <el-dialog title="技师统计" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
    <!-- <el-form size="small" ref="changeform" :model="changeform" :rules="formRules" :label-width="formLabelWidth"> -->
    <div class="common-form">当日数据统计</div>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">技师收益：</span>{{statisticsList.today?statisticsList. today.price :0}}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">评分：</span>{{statisticsList.today?statisticsList.today.score :0}}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">车费：</span>{{statisticsList.today?statisticsList.today.fare_price:0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单量：</span>{{statisticsList.today?statisticsList.today.order_total:0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单金额：</span>{{statisticsList.today?statisticsList.today.order_price :0}}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款订单量：</span>{{statisticsList.today?statisticsList. today.refund_total :0}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款金额：</span>{{statisticsList.today?statisticsList. today.refund_price :0}}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟订单：</span>{{statisticsList.today?statisticsList. today.clock_total :0}}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟金额：</span>{{statisticsList.today?statisticsList. today.clock_price :0}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">服务时间：</span>{{statisticsList.today?statisticsList. today.serviceTime:0 }}</div>
      </el-col>
    </el-row>
    <!-- 第二 -->
    <div class="common-form">本月数据统计</div>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">技师收益：</span>{{statisticsList.month?statisticsList.month.price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">评分：</span>{{statisticsList.month?statisticsList.month.score :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">车费：</span>{{statisticsList.month?statisticsList.month.fare_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单量：</span>{{statisticsList.month?statisticsList.month.order_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单金额：</span>{{statisticsList.month?statisticsList.month.order_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款订单量：</span>{{statisticsList.month?statisticsList.month.refund_total :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款金额：</span>{{statisticsList.month?statisticsList.month.refund_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟订单：</span>{{statisticsList.month?statisticsList.month.clock_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟金额：</span>{{statisticsList.month?statisticsList.month.clock_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">服务时间：</span>{{statisticsList.month?statisticsList.month.serviceTime :0 }}</div>
      </el-col>
    </el-row>
    <!-- 第三 -->
    <div class="common-form">上月数据统计</div>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">技师收益：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">评分：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.score :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">车费：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.fare_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单量：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.order_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单金额：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.order_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款订单量：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.refund_total :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款金额：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.refund_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟订单：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.clock_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟金额：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.clock_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">服务时间：</span>{{statisticsList.lastMonth?statisticsList.lastMonth.serviceTime :0 }}</div>
      </el-col>
    </el-row>
    <!-- 总计 -->
    <div class="common-form">总数据统计</div>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">技师收益：</span>{{statisticsList.total?statisticsList. total.price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">评分：</span>{{statisticsList.total?statisticsList. total.score :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">车费：</span>{{statisticsList.total?statisticsList. total.fare_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单量：</span>{{statisticsList.total?statisticsList. total.order_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">订单金额：</span>{{statisticsList.total?statisticsList. total.order_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款订单量：</span>{{statisticsList.total?statisticsList. total.refund_total :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">退款金额：</span>{{statisticsList.total?statisticsList. total.refund_price :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟订单：</span>{{statisticsList.total?statisticsList. total.clock_total :0 }}</div>
      </el-col>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">加钟金额：</span>{{statisticsList.total?statisticsList. total.clock_price :0 }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" style="margin:5px 0">
        <div>
          <span class="gray9">服务时间：</span>{{statisticsList.total?statisticsList. total.serviceTime :0 }}</div>
      </el-col>
    </el-row>
    <!-- </el-form> -->
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      waiter_user_id: "",
      statisticsList: {},
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false
      /*form验证*/
    };
  },
  props: ["open_countnum", "form"],
  created() {
    this.dialogVisible = this.open_countnum;
    this.waiterUserId = this.form.waiterUserId;
    this.getstatistics();
  },
  methods: {
    /*添加用户*/
    getstatistics() {
      let self = this;
      self.loading = true;
      let params = {};
      params.waiterUserId = this.waiterUserId;
      Technician.statistics(params, true)
        .then(data => {
          self.loading = false;
          self.statisticsList = data.data;
          // self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/countnum.vue